import { ParameterType } from '../enums/parameter-type.enum'

export class ParameterValue {
	public constructor(
		public readonly type: ParameterType,
		public readonly value: string[]
	) { }

	public toString(): string {
		if (this.value.length === 0) {
			return "";
		}

		return [this.type, this.value].join("-");
	}
}
